import { render, staticRenderFns } from "./CategoryCard.vue?vue&type=template&id=75e991c8&scoped=true"
import script from "./CategoryCard.vue?vue&type=script&lang=ts"
export * from "./CategoryCard.vue?vue&type=script&lang=ts"
import style0 from "./CategoryCard.vue?vue&type=style&index=0&id=75e991c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e991c8",
  null
  
)

export default component.exports